import ExcelJS from 'exceljs';
import moment from 'moment';
import { EXCEPTION_LABELS } from '../../jspdf/DailyReconciliationPdf';

const thinBorder: Partial<ExcelJS.Borders> = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
};

// Mirrors DailyReconciliationPdf: same columns, labels and summary counts.
const DailyReconciliationExcel = async (reportData: any, formData: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Daily Reconciliation');

    // The backend maps Start Date onto @ReportDate and falls back to today.
    const reportDate = formData?.StartDate
        ? moment(formData.StartDate).format('MM/DD/YYYY')
        : moment().format('MM/DD/YYYY');

    const rows: any[] = Array.isArray(reportData) ? reportData : [];

    worksheet.mergeCells('A1:F1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = 'Daily Reconciliation';
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { size: 18, bold: true };

    worksheet.getCell('A2').value = 'Report Date';
    worksheet.getCell('A2').font = { bold: true };
    worksheet.getCell('B2').value = reportDate;
    worksheet.getCell('E2').value = 'Total exceptions';
    worksheet.getCell('E2').font = { bold: true };
    worksheet.getCell('F2').value = rows.length;

    const counts = rows.reduce((acc: Record<number, number>, r: any) => {
        const t = Number(r.ExceptionType);
        acc[t] = (acc[t] || 0) + 1;
        return acc;
    }, {});
    worksheet.getCell('A3').value = [3, 1, 2]
        .filter(t => counts[t])
        .map(t => `${EXCEPTION_LABELS[t]}: ${counts[t]}`)
        .join('    ');

    const headerRowNumber = 5;
    const headerRow = worksheet.getRow(headerRowNumber);
    headerRow.values = ['Exception', 'Name', 'Site', 'Scheduled Shift', 'Clock In', 'Clock Out'];
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = thinBorder;
    });

    // The proc already orders by ExceptionType then PersonnelName -- preserve it.
    rows.forEach((item: any) => {
        const row = worksheet.addRow([
            EXCEPTION_LABELS[Number(item.ExceptionType)] ?? String(item.ExceptionType ?? ''),
            item.PersonnelName ?? '',
            item.SiteName ?? '',
            item.ScheduledShift ?? '',
            item.ClockIn ?? '--',
            item.ClockOut ?? '--',
        ]);
        row.eachCell((cell, colNumber) => {
            cell.alignment = { horizontal: colNumber >= 4 ? 'center' : 'left', vertical: 'middle' };
            cell.border = thinBorder;
        });
    });

    worksheet.columns = [
        { width: 20 },
        { width: 32 },
        { width: 40 },
        { width: 24 },
        { width: 16 },
        { width: 16 },
    ];
    worksheet.views = [{ state: 'frozen', xSplit: 0, ySplit: headerRowNumber }];
    worksheet.autoFilter = { from: { row: headerRowNumber, column: 1 }, to: { row: headerRowNumber, column: 6 } };

    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
};

export default DailyReconciliationExcel;
